export default {
  root: ({ props }) => ({
    class: [
      // Flexbox
      'flex gap-2',

      { 'flex-col': props.orientation == 'horizontal', 'flex-row': props.orientation == 'vertical' }
    ]
  }),
  metercontainer: ({ props }) => ({
    class: [
      // Flexbox
      'flex',

      { 'flex-col': props.orientation === 'vertical' },

      // Sizing
      { 'w-2 h-full': props.orientation === 'vertical' },
      { 'h-1': props.orientation === 'horizontal' },

      // Colors
      'bg-gray-600'
    ]
  }),
  meter: ({ props }) => ({
    class: [
      // Shape
      'border-0',

      // Colors
      'bg-primary-400'
    ]
  }),
  labellist: ({ props }) => ({
    class: [
      // Display & Flexbox
      'flex flex-wrap',

      { 'gap-4': props.labelOrientation === 'horizontal' },

      { 'gap-2': props.labelOrientation === 'vertical' },

      { 'flex-col': props.labelOrientation === 'vertical' },

      // Conditional Alignment - Horizontal
      {
        'align-end': props.labelOrientation === 'horizontal' && props.labelPosition === 'end',
        'align-start': props.labelOrientation === 'horizontal' && props.labelPosition === 'start'
      },

      // Conditional Alignment - Vertical
      {
        'justify-end': props.labelOrientation === 'vertical' && props.labelPosition === 'end',
        'justify-start': props.labelOrientation === 'vertical' && props.labelPosition === 'start'
      },

      // List Styling
      'm-0 p-0 list-none'
    ]
  }),
  labellistitem: {
    class: [
      // Flexbox
      'inline-flex',
      'items-center',
      'gap-2',

      // Text
      'text-sm'
    ]
  },
  labellisttype: {
    class: [
      // Display
      'inline-flex',

      // Background Color
      'bg-primary-400',

      // Size
      'w-2 h-2'
    ]
  }
}
